import { Routes } from '@angular/router';
import { MenuGuardService } from './core/guards/menu-guard.service';
import { AuthGuard } from './core/guards/auth-guard.service';
import { RedirectionGuardService } from './core/guards/redirection-guard.service';
import { LoginByNonceGuardService } from './core/guards/login-by-nonce-guard.service';
import { AdobeCallbackComponent } from './core/auth/adobe-callback/adobe-callback.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'login',
    loadComponent: () => import('./core/auth/login/login.component').then(m => m.LoginComponent),
    canActivate: [RedirectionGuardService],
  },
  {
    path: 'login-local',
    loadComponent: () => import('./core/auth/login/login.component').then(m => m.LoginComponent),
    canActivate: [RedirectionGuardService],
  },
  {
    path: 'login/:nonceId',
    loadComponent: () => import('./core/auth/login/login.component').then(m => m.LoginComponent),
    canActivate: [LoginByNonceGuardService, RedirectionGuardService],
  },
  {
    path: 'adobe-callback',
    component: AdobeCallbackComponent,
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/dashboard/components/dashboard/dashboard.component').then(
        m => m.DashboardComponent
      ),
    canActivate: [MenuGuardService, AuthGuard],
    data: { menuId: 1000 },
  },
  {
    path: 'contracts',
    loadChildren: () =>
      import('./features/contracts/contracts.routes').then(mod => mod.CONTRACTS_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'manage',
    loadChildren: () => import('./features/manage/manage.routes').then(mod => mod.MANAGE_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'costs',
    loadChildren: () => import('./features/costs/costs.routes').then(mod => mod.COSTS_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    loadChildren: () => import('./features/reports/reports.routes').then(mod => mod.REPORTS_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'analytics',
    loadChildren: () =>
      import('./features/analytics/analytics.routes').then(mod => mod.ANALYTICS_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'audits',
    loadChildren: () => import('./features/audits/audits.routes').then(mod => mod.AUDIT_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./features/settings/settings.routes').then(mod => mod.SETTINGS_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'help',
    loadChildren: () => import('./features/help/help.routes').then(mod => mod.HELP_ROUTES),
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];
